import { useFormContext } from '@sravni/cosago-react-library/lib/hooks';
import { useCallback, useMemo } from 'react';

import type { TWorkplaceFormFields } from 'entities/creditForm';

export const useUpdateWorkFields = () => {
  const { setValue } = useFormContext<TWorkplaceFormFields>();

  const updateWorkFields = useCallback(
    (updateData: Partial<TWorkplaceFormFields>, shouldValidate = false) => {
      Object.keys(updateData).forEach((key) => {
        const fieldKey = key as keyof TWorkplaceFormFields;
        setValue(fieldKey, updateData[fieldKey], { shouldValidate });
      });
    },
    [setValue],
  );

  return useMemo(
    () => ({
      updateWorkFields,
      resetFields: () =>
        updateWorkFields({
          workOrganizationName: '',
          workAddress: null,
          workPhone: '',
          employerInn: '',
          areaOfEmployment: null,
          employerType: null,
        }),
    }),
    [updateWorkFields],
  );
};
